import { Users } from 'lucide-react';
import { useIamUsers, useDeleteIamUser, type IamUser } from '@/api/s3';
import { IamListPage } from '../IamListPage';

/** IAM users — list, view (detail), create and delete. */
export function UserList({ serviceId }: { serviceId: string }) {
  const { data = [], isLoading, isError, refetch } = useIamUsers(serviceId);
  const del = useDeleteIamUser(serviceId);

  return (
    <IamListPage<IamUser>
      serviceId={serviceId}
      resource="users"
      title="Users"
      description="IAM users for this storage service."
      createLabel="Create user"
      entities={data}
      isLoading={isLoading}
      isError={isError}
      refetch={refetch}
      nameOf={(u) => u.user_name}
      dateOf={(u) => u.create_date}
      emptyIcon={<Users size={20} />}
      emptyTitle="No users yet"
      emptyDescription="Create an IAM user to grant scoped, per-identity access to this service."
      del={del}
      entityLabel="user"
    />
  );
}
